export default function Footer() {
  const footerLinks = {
    service: { title: '服务导航', links: [
      { label: '热播榜单', href: '#ranking' },
      { label: '热门话题', href: '#topics' },
      { label: '精选推荐', href: '#cards' },
      { label: '最新动态', href: '#updates' },
      { label: '专题合集', href: '#index' },
    ]},
    support: { title: '帮助支持', links: [
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '移动观影', href: '#app' },
      { label: '关于我们', href: '#about' },
    ]},
    partners: { title: '合作伙伴', links: [] },
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-base"></i>
              </span>
              <span className="text-lg font-heading font-bold text-foreground-950">
                无极电影网
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              无极电影网是国内领先的免费影视在线观看平台，提供高清电影、热门电视剧、经典综艺和人气动漫等全品类内容。智能CDN加速，不卡顿流畅观影，蓝光画质免费看。
            </p>
          </div>

          {[footerLinks.service, footerLinks.support].map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-heading font-bold text-foreground-800 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-xs md:text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-800 mb-4">
              {footerLinks.partners.title}
            </h4>
            <p className="text-xs text-foreground-500">
              诚邀优质平台合作，共建影视生态
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2024 无极电影网 wujimovie.com 版权所有 | 免费影视不缓冲在线观看
          </p>
          <p className="text-xs text-foreground-500">
            每日更新，高清蓝光，流畅播放，零卡顿观影体验
          </p>
        </div>
      </div>
    </footer>
  );
}